(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["patrick-event-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-pm-event-popup]');
    if (!root) return;

    var SEEN_KEY = 'pm_event_popup_seen';
    try {
      if (sessionStorage.getItem(SEEN_KEY) === '1') return;
    } catch (e) {}

    var delay = (parseFloat(root.getAttribute('data-delay')) || 2) * 1000;

    function close() {
      root.setAttribute('data-open', 'false');
      root.setAttribute('aria-hidden', 'true');
      try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
      setTimeout(function () { root.setAttribute('hidden', ''); }, 400);
    }

    function open() {
      root.removeAttribute('hidden');
      void root.offsetWidth;
      root.setAttribute('data-open', 'true');
      root.setAttribute('aria-hidden', 'false');
    }

    root.querySelectorAll('[data-pm-event-popup-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    var link = root.querySelector('.pm-event-popup__link');
    if (link) {
      link.addEventListener('click', function () {
        try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') close();
    });

    setTimeout(open, delay);
  })();
  } catch(e) { console.error(e); }
})();

})();
